import { formatMoneyWithCurrency } from 'src/utils/formatter'
import './styles.scss'
import Banks_SVG from '../../../../../../../../assets/svg/svg_banks';
import { banksFormat } from 'src/utils/bankList';

export const DropdownBalances = ({ source }) => {
  return (
    <>
      <div className="tw-px-7 tw-py-5 tw-flex tw-flex-col tw-gap-6">
        <div className='tw-flex tw-justify-between tw-items-center'>
          <p className="tw-font-medium tw-text-lg tw-text-black !tw-p-0 !tw-m-0">Detalles de cuentas bancarias</p>
        </div>
        <div className="tw-flex tw-gap-6">
          <div className="tw-w-full tw-border-solid tw-border-[1px] tw-border-gray-300 tw-rounded-md">
            {/* Cabecera */}
            <div className="tw-w-full tw-bg-gray-200 tw-h-[40px] borderBgray tw-flex tw-px-4 tw-items-center">
              <div className="tw-flex-1 tw-min-w-[100px]"> {/* Banco ocupa espacio disponible */}
                <p className='!tw-p-0 !tw-m-0 tw-font-medium tw-text-black tw-text-sm'>Banco</p>
              </div>
              <div className="tw-flex-1 tw-min-w-[150px]"> {/* Cuenta corriente ocupa espacio disponible */}
                <p className='!tw-p-0 !tw-m-0 tw-font-medium tw-text-black tw-text-sm'>Cuenta corriente</p>
              </div>
              <div className="tw-flex-1 tw-min-w-[150px]"> {/* Saldo ocupa espacio disponible */}
                <p className='!tw-p-0 !tw-m-0 tw-font-medium tw-text-black tw-text-sm'>Saldo</p>
              </div>
              <div className="tw-w-[200px] tw-flex-none tw-text-right"> {/* Línea de crédito fijo y alineado a la derecha */}
                <p className='!tw-p-0 !tw-m-0 tw-font-medium tw-text-black tw-text-sm'>Línea de crédito</p>
              </div>
            </div>

            {/* Filas de datos */}
            <div className='tw-max-h-[280px] tw-overflow-y-auto'>
              {source?.map((item, index) => (
                <div key={index} className={`tw-w-full tw-h-[40px] ${index !== source.length - 1 ? 'borderBgray' : ''} tw-flex tw-px-4 tw-items-center`}>
                  <div className="tw-flex-1 tw-min-w-[100px] tw-flex tw-items-center tw-gap-2"> {/* Banco */}
                    <img src={Banks_SVG(item.bankId)} className="tw-size-4 tw-rounded-sm" alt="" />
                    <p className='!tw-p-0 !tw-m-0 tw-font-normal tw-text-black tw-text-sm tw-capitalize'>{banksFormat[item.bankId]}</p>
                  </div>
                  <div className="tw-flex-1 tw-min-w-[150px]"> {/* Cuenta corriente */}
                    <p className='!tw-p-0 !tw-m-0 tw-font-light tw-text-black tw-text-sm tw-uppercase'>{item.accountNumber}</p>
                  </div>
                  <div className="tw-flex-1 tw-min-w-[150px]"> {/* Saldo */}
                    <p className='!tw-p-0 !tw-m-0 tw-font-light tw-text-black tw-text-sm tw-uppercase'>{formatMoneyWithCurrency(item.availableBalance, item.currencyType)}</p>
                  </div>
                  <div className="tw-w-[200px] tw-flex-none tw-text-right"> {/* Línea de crédito fijo y alineado a la derecha */}
                    <p className='!tw-p-0 !tw-m-0 tw-font-light tw-text-black tw-text-sm'>{formatMoneyWithCurrency(item.creditLineAvailable, item.currencyType)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}